import React, { useState, useEffect, useCallback } from 'react';
import CampoDataHora from '../components/CampoDataHora';
import ModalConfirmar from '../components/ModalConfirmar';
import SelectColaborador from '../components/SelectColaborador';

const ETAPAS = [
  { key: 'lead',        label: 'Lead',        cor: '#6b7280' },
  { key: '1contato',    label: '1º Contato',  cor: '#3b82f6' },
  { key: 'viabilidade', label: 'Viabilidade', cor: '#f59e0b' },
  { key: 'negociacao',  label: 'Negociação',  cor: '#8b5cf6' },
  { key: 'ganho',         label: 'Ganho',         cor: '#16a34a' },
  { key: 'perdido',       label: 'Perdido',       cor: '#dc2626' },
  { key: 'sem-interacao', label: 'Sem interação', cor: '#9ca3af' },
];

const FORM_VAZIO = { nome_cliente: '', telefone: '', sdr: '', closer: '', etapa: 'lead' };

// Pré-seleciona a pessoa do login (ganho de tempo): SDR logado → campo SDR;
// Closer/Admin → campos Closer E SDR com a própria pessoa. Segue editável.
function formNovaOportunidade() {
  const nome = localStorage.getItem('nomeUsuario') || '';
  const cargo = (localStorage.getItem('cargoUsuario') || '').toLowerCase();
  const ehCloser = cargo.includes('closer') || cargo.includes('admin');
  return {
    ...FORM_VAZIO,
    sdr: (cargo.includes('sdr') || ehCloser) ? nome : '',
    closer: ehCloser ? nome : '',
  };
}
const TAREFA_NOVA = { descricao: '', data_agendada: '', destinado_a: '', realizado: '', subagenda: 'comercial' };
const SUBAGENDAS_OP = [['', '📥 Geral'], ['administrativo', '🗂️ Administrativo'], ['comercial', '💼 Comercial'], ['cliente', '👥 Cliente'], ['demandas', '⚖️ Demandas Processuais'], ['pessoal', '🏠 Pessoal']];

const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };

function token() { return localStorage.getItem('token'); }
function isAdmin() { return localStorage.getItem('nomeUsuario') === 'Vagner Freitas'; }

async function apiFetch(url, opts = {}) {
  const res = await fetch(url, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.erro || 'Erro');
  return data;
}

function fmtDt(iso) { if (!iso) return '—'; return new Date(iso).toLocaleString('pt-BR'); }

function statusTarefa(t) {
  if (t.realizado) return { label: 'Concluída', cor: '#16a34a', bg: '#f0fdf4' };
  if (!t.data_agendada) return { label: 'Sem data', cor: '#9ca3af', bg: '#f9fafb' };
  if (new Date(t.data_agendada) < new Date()) return { label: 'Atrasada', cor: '#dc2626', bg: '#fef2f2' };
  return { label: 'Pendente', cor: '#d97706', bg: '#fffbeb' };
}

function TarefasOportunidade({ op }) {
  const [tarefas, setTarefas] = useState([]);
  const [adicionando, setAdicionando] = useState(false);
  const [novaTarefa, setNovaTarefa] = useState({ ...TAREFA_NOVA });
  const [salvando, setSalvando] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [confirmacao, setConfirmacao] = useState(null);

  const carregar = useCallback(() => {
    fetch(`/agenda?oportunidade_id=${op._id}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(setTarefas).catch(() => {});
  }, [op._id]);

  useEffect(() => { carregar(); }, [carregar]);

  async function salvarNova() {
    if (!novaTarefa.descricao.trim()) return alert('Preencha a descrição da tarefa.');
    setSalvando(true);
    await fetch('/agenda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ ...novaTarefa, oportunidade_id: op._id, oportunidade_nome: op.nome_cliente }),
    });
    setSalvando(false);
    setNovaTarefa({ ...TAREFA_NOVA });
    setAdicionando(false);
    carregar();
  }

  async function salvarEdicao(id) {
    await fetch(`/agenda/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify(editForm),
    });
    setEditandoId(null);
    carregar();
  }

  async function excluir() {
    await fetch(`/agenda/${confirmacao}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmacao(null);
    carregar();
  }

  return (
    <div style={{ borderTop: '1px solid #e8eaed', marginTop: 10, paddingTop: 10 }}>
      {confirmacao && <ModalConfirmar mensagem="Excluir esta tarefa?" onConfirmar={excluir} onCancelar={() => setConfirmacao(null)} />}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Tarefas ({tarefas.length})
        </div>
        {!adicionando && (
          <button onClick={() => setAdicionando(true)} style={{ background: '#0a1628', color: '#fff', padding: '3px 10px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
            + Nova Tarefa
          </button>
        )}
      </div>

      {adicionando && (
        <div style={{ background: '#f9fafb', borderRadius: 4, padding: 12, marginBottom: 8, border: '1px solid #c8d0da' }}>
          <div style={{ display: 'grid', gap: 8 }}>
            <div>
              <label style={lbl}>Criado em</label>
              <input value={new Date().toLocaleString('pt-BR')} readOnly style={{ ...inp, background: '#f3f4f6', color: '#9ca3af' }} />
            </div>
            <div>
              <label style={lbl}>Descrição da tarefa *</label>
              <textarea value={novaTarefa.descricao} onChange={e => setNovaTarefa(f => ({ ...f, descricao: e.target.value }))} rows={2}
                placeholder="Descreva o que precisa ser feito..."
                style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div>
                <label style={lbl}>Data e hora de realização</label>
                <CampoDataHora value={novaTarefa.data_agendada} onChange={v => setNovaTarefa(f => ({ ...f, data_agendada: v }))} style={{ ...inp }} />
              </div>
              <div>
                <label style={lbl}>Destinado a</label>
                <SelectColaborador value={novaTarefa.destinado_a} onChange={v => setNovaTarefa(f => ({ ...f, destinado_a: v }))} placeholder="Selecione..." />
              </div>
            </div>
            <div>
              <label style={lbl}>Subagenda</label>
              <select value={novaTarefa.subagenda || 'comercial'} onChange={e => setNovaTarefa(f => ({ ...f, subagenda: e.target.value }))} style={{ ...inp, width: '100%' }}>
                {SUBAGENDAS_OP.map(([v, l]) => <option key={v || 'g'} value={v}>{l}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>O que foi feito</label>
              <textarea value={novaTarefa.realizado} onChange={e => setNovaTarefa(f => ({ ...f, realizado: e.target.value }))} rows={2}
                placeholder="Preencherá após realização..."
                style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
            <button onClick={salvarNova} disabled={salvando} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
              {salvando ? 'Salvando...' : 'Salvar'}
            </button>
            <button onClick={() => { setAdicionando(false); setNovaTarefa({ ...TAREFA_NOVA }); }} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
          </div>
        </div>
      )}

      {tarefas.length === 0 && !adicionando && (
        <div style={{ fontSize: 12, color: '#9ca3af', padding: '6px 0' }}>Nenhuma tarefa cadastrada.</div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {tarefas.map(t => {
          const status = statusTarefa(t);
          const bloqueado = t.realizado && !isAdmin();
          return (
            <div key={t._id} style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: 10 }}>
              {editandoId === t._id ? (
                <div style={{ display: 'grid', gap: 8 }}>
                  <div>
                    <label style={lbl}>Descrição</label>
                    <textarea value={editForm.descricao || ''} onChange={e => setEditForm(f => ({ ...f, descricao: e.target.value }))} rows={2}
                      style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    <div>
                      <label style={lbl}>Data e hora de realização</label>
                      <CampoDataHora value={editForm.data_agendada || ''} onChange={v => setEditForm(f => ({ ...f, data_agendada: v }))} style={{ ...inp }} />
                    </div>
                    <div>
                      <label style={lbl}>Destinado a</label>
                      <SelectColaborador value={editForm.destinado_a || ''} onChange={v => setEditForm(f => ({ ...f, destinado_a: v }))} />
                    </div>
                  </div>
                  <div>
                    <label style={lbl}>O que foi feito</label>
                    <textarea value={editForm.realizado || ''} onChange={e => setEditForm(f => ({ ...f, realizado: e.target.value }))} rows={2}
                      style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => salvarEdicao(t._id)} style={{ background: '#0a1628', color: '#fff', padding: '3px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' }}>Salvar</button>
                    <button onClick={() => setEditandoId(null)} style={{ background: '#f3f4f6', color: '#374151', padding: '3px 10px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                    <div style={{ fontSize: 11, color: '#9ca3af' }}>Criado em: {fmtDt(t.criado_em)}</div>
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                      <span style={{ background: status.bg, color: status.cor, padding: '1px 7px', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{status.label}</span>
                      {bloqueado ? (
                        <span style={{ fontSize: 11, color: '#dc2626', background: '#fef2f2', padding: '2px 6px', borderRadius: 4, fontWeight: 600 }}>Bloq.</span>
                      ) : (
                        <>
                          <button onClick={() => { setEditandoId(t._id); setEditForm({ descricao: t.descricao, data_agendada: t.data_agendada, destinado_a: t.destinado_a, realizado: t.realizado }); }}
                            style={{ background: '#f3f4f6', color: '#374151', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #d1d5db', cursor: 'pointer' }}>Editar</button>
                          <button onClick={() => setConfirmacao(t._id)} style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #fecaca', cursor: 'pointer' }}>Excluir</button>
                        </>
                      )}
                    </div>
                  </div>
                  <div style={{ fontSize: 13, color: '#111827', lineHeight: 1.5, marginBottom: 6 }}>{t.descricao}</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
                    <div style={{ background: '#eff6ff', borderRadius: 3, padding: '5px 8px' }}>
                      <div style={{ fontSize: 10, color: '#3b82f6', fontWeight: 600 }}>DATA/HORA REALIZAÇÃO</div>
                      <div style={{ fontSize: 12, color: '#1e40af', marginTop: 1 }}>{t.data_agendada ? new Date(t.data_agendada).toLocaleString('pt-BR') : '—'}</div>
                    </div>
                    <div style={{ background: '#f5f3ff', borderRadius: 3, padding: '5px 8px' }}>
                      <div style={{ fontSize: 10, color: '#7c3aed', fontWeight: 600 }}>DESTINADO A</div>
                      <div style={{ fontSize: 12, color: '#6d28d9', marginTop: 1 }}>{t.destinado_a || '—'}</div>
                    </div>
                  </div>
                  <div style={{ background: t.realizado ? '#f0fdf4' : '#fafafa', borderRadius: 3, padding: '5px 8px', border: `1px solid ${t.realizado ? '#bbf7d0' : '#e5e7eb'}` }}>
                    <div style={{ fontSize: 10, color: t.realizado ? '#16a34a' : '#9ca3af', fontWeight: 600, marginBottom: 2 }}>O QUE FOI FEITO</div>
                    <div style={{ fontSize: 12, color: t.realizado ? '#15803d' : '#9ca3af' }}>{t.realizado || 'Ainda não preenchido'}</div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function hojeStr() { return new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10); }
function brtStr(d) { return new Date(new Date(d).getTime() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10); }

export default function Oportunidades() {
  const [lista, setLista] = useState([]);
  const [busca, setBusca] = useState('');
  const [filtroEtapa, setFiltroEtapa] = useState('');
  const [filtroCloser, setFiltroCloser] = useState('');
  const [filtroSdr, setFiltroSdr] = useState('');
  const [filtroPeriodo, setFiltroPeriodo] = useState('hoje');
  const [filtroDataDe, setFiltroDataDe] = useState('');
  const [filtroDataAte, setFiltroDataAte] = useState('');
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(FORM_VAZIO);
  const [editandoId, setEditandoId] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [confirmacao, setConfirmacao] = useState(null);
  const [expandidas, setExpandidas] = useState({});

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filtroEtapa) params.append('etapa', filtroEtapa);
      if (busca) params.append('busca', busca);
      let data = await apiFetch(`/oportunidades?${params}`);
      if (filtroCloser) data = data.filter(op => op.closer === filtroCloser);
      if (filtroSdr) data = data.filter(op => op.sdr === filtroSdr);
      if (filtroPeriodo === 'personalizado') {
        data = data.filter(op => {
          if (!op.criado_em) return false;
          const d = brtStr(op.criado_em);
          if (filtroDataDe && d < filtroDataDe) return false;
          if (filtroDataAte && d > filtroDataAte) return false;
          return true;
        });
      } else if (filtroPeriodo !== 'todos') {
        const hoje = hojeStr();
        data = data.filter(op => {
          if (!op.criado_em) return false;
          const d = brtStr(op.criado_em);
          if (filtroPeriodo === 'hoje') return d === hoje;
          if (filtroPeriodo === 'ontem') return d === brtStr(Date.now() - 86400000);
          if (filtroPeriodo === '7dias') { const lim = new Date(); lim.setDate(lim.getDate() - 6); return new Date(op.criado_em) >= lim; }
          if (filtroPeriodo === 'mes') return d.slice(0, 7) === hoje.slice(0, 7);
          return true;
        });
      }
      setLista(data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [busca, filtroEtapa, filtroCloser, filtroSdr, filtroPeriodo, filtroDataDe, filtroDataAte]);

  useEffect(() => { const t = setTimeout(carregar, 300); return () => clearTimeout(t); }, [carregar]);

  function abrirNovo() { setForm(formNovaOportunidade()); setEditandoId(null); setModal(true); }
  function abrirEditar(op) {
    setForm({ nome_cliente: op.nome_cliente, telefone: op.telefone, sdr: op.sdr, closer: op.closer, etapa: op.etapa });
    setEditandoId(op._id);
    setModal(true);
  }

  async function salvar(e) {
    e.preventDefault();
    if (!editandoId && !(form.closer || '').trim()) {
      return alert('Selecione o closer que vai atender antes de lançar a oportunidade.');
    }
    setSalvando(true);
    try {
      if (editandoId) {
        const atualizado = await apiFetch(`/oportunidades/${editandoId}`, { method: 'PUT', body: JSON.stringify(form) });
        setLista(l => l.map(x => x._id === editandoId ? atualizado : x));
      } else {
        const nova = await apiFetch('/oportunidades', { method: 'POST', body: JSON.stringify(form) });
        setLista(l => [nova, ...l]);
      }
      setModal(false);
    } catch (e) { alert(e.message); }
    finally { setSalvando(false); }
  }

  async function moverEtapa(op, novaEtapa) {
    try {
      const atualizado = await apiFetch(`/oportunidades/${op._id}`, { method: 'PUT', body: JSON.stringify({ ...op, etapa: novaEtapa }) });
      setLista(l => l.map(x => x._id === op._id ? atualizado : x));
    } catch (e) { alert(e.message); }
  }

  async function excluir() {
    try {
      await apiFetch(`/oportunidades/${confirmacao._id}`, { method: 'DELETE' });
      setLista(l => l.filter(x => x._id !== confirmacao._id));
      setConfirmacao(null);
    } catch (e) { alert(e.message); }
  }

  function toggleExpandir(id) { setExpandidas(e => ({ ...e, [id]: !e[id] })); }
  function etapaInfo(key) { return ETAPAS.find(e => e.key === key) || ETAPAS[0]; }
  function formatarData(d) { if (!d) return '-'; return new Date(d).toLocaleString('pt-BR'); }

  return (
    <div>
      {confirmacao && (
        <ModalConfirmar mensagem={`Excluir a oportunidade de "${confirmacao.nome_cliente}"?`} onConfirmar={excluir} onCancelar={() => setConfirmacao(null)} />
      )}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 4, width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '4px 4px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontSize: 13, fontWeight: 700 }}>{editandoId ? 'Editar Oportunidade' : 'Nova Oportunidade'}</span>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
            </div>
            <form onSubmit={salvar} style={{ padding: '10px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <label style={lbl}>Nome do Cliente <span style={{ color: '#dc2626' }}>*</span></label>
                <input style={inp} value={form.nome_cliente} onChange={e => setForm(f => ({ ...f, nome_cliente: e.target.value }))} placeholder="Nome do cliente" required />
              </div>
              <div>
                <label style={lbl}>Telefone</label>
                <input style={inp} value={form.telefone} onChange={e => setForm(f => ({ ...f, telefone: e.target.value }))} placeholder="(11) 99999-9999" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div>
                  <label style={lbl}>SDR</label>
                  <SelectColaborador value={form.sdr} onChange={v => setForm(f => ({ ...f, sdr: v }))} placeholder="Selecione o SDR" />
                </div>
                <div>
                  <label style={lbl}>Closer</label>
                  <SelectColaborador apenasClosers value={form.closer} onChange={v => setForm(f => ({ ...f, closer: v }))} placeholder="Selecione o Closer" />
                </div>
              </div>
              <div>
                <label style={lbl}>Etapa</label>
                <select style={inp} value={form.etapa} onChange={e => setForm(f => ({ ...f, etapa: e.target.value }))}>
                  {ETAPAS.map(e => <option key={e.key} value={e.key}>{e.label}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', gap: 8, paddingTop: 4, borderTop: '1px solid #e8eaed', marginTop: 4 }}>
                <button type="submit" disabled={salvando} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontWeight: 600, fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                  {salvando ? 'Salvando...' : editandoId ? 'Salvar' : 'Criar'}
                </button>
                <button type="button" onClick={() => setModal(false)} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', fontSize: 12, border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer' }}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>Oportunidades</h1>
          <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>{lista.length} oportunidade(s)</p>
        </div>
        <button onClick={abrirNovo} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer', fontWeight: 600 }}>+ Nova Oportunidade</button>
      </div>

      {/* Filtros de período */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 8, flexWrap: 'wrap' }}>
        {[{ key: 'hoje', label: 'Hoje' }, { key: 'ontem', label: 'Ontem' }, { key: '7dias', label: '7 dias' }, { key: 'mes', label: 'Mês atual' }, { key: 'todos', label: 'Todos' }, { key: 'personalizado', label: '📅 Personalizado' }].map(p => (
          <button key={p.key} onClick={() => setFiltroPeriodo(p.key)}
            style={{ padding: '3px 10px', borderRadius: 4, fontSize: 12, fontWeight: filtroPeriodo === p.key ? 700 : 400, border: '1px solid', borderColor: filtroPeriodo === p.key ? '#0a1628' : '#d1d5db', background: filtroPeriodo === p.key ? '#0a1628' : '#fff', color: filtroPeriodo === p.key ? '#fff' : '#374151', cursor: 'pointer' }}>
            {p.label}
          </button>
        ))}
      </div>
      {filtroPeriodo === 'personalizado' && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
          <label style={{ fontSize: 12, color: '#374151', fontWeight: 600 }}>De:</label>
          <input type="date" value={filtroDataDe} onChange={e => setFiltroDataDe(e.target.value)} style={{ ...inp, width: 140 }} />
          <label style={{ fontSize: 12, color: '#374151', fontWeight: 600 }}>Até:</label>
          <input type="date" value={filtroDataAte} onChange={e => setFiltroDataAte(e.target.value)} style={{ ...inp, width: 140 }} />
          {(filtroDataDe || filtroDataAte) && (
            <button onClick={() => { setFiltroDataDe(''); setFiltroDataAte(''); }} style={{ fontSize: 12, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>✕ Limpar</button>
          )}
        </div>
      )}

      {/* Filtros de busca */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 8, marginBottom: 8 }}>
        <input style={inp} value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por cliente, SDR, Closer..." />
        <select style={inp} value={filtroEtapa} onChange={e => setFiltroEtapa(e.target.value)}>
          <option value="">Todas as etapas</option>
          {ETAPAS.map(e => <option key={e.key} value={e.key}>{e.label}</option>)}
        </select>
        <select style={inp} value={filtroSdr} onChange={e => setFiltroSdr(e.target.value)}>
          <option value="">Todos os SDRs</option>
          {[...new Set(lista.map(op => op.sdr).filter(Boolean))].sort().map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select style={inp} value={filtroCloser} onChange={e => setFiltroCloser(e.target.value)}>
          <option value="">Todos os closers</option>
          {[...new Set(lista.map(op => op.closer).filter(Boolean))].sort().map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      {/* Resumo por etapa */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
        {ETAPAS.map(e => {
          const qtd = lista.filter(op => op.etapa === e.key).length;
          return (
            <div key={e.key} onClick={() => setFiltroEtapa(filtroEtapa === e.key ? '' : e.key)}
              style={{ background: filtroEtapa === e.key ? e.cor : '#fff', color: filtroEtapa === e.key ? '#fff' : e.cor, border: `1px solid ${e.cor}`, borderRadius: 12, padding: '2px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
              {e.label} ({qtd})
            </div>
          );
        })}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
      ) : lista.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', color: '#6b7280', fontSize: 13 }}>
          <p style={{ fontWeight: 500 }}>Nenhuma oportunidade encontrada</p>
          <button onClick={abrirNovo} style={{ background: '#0a1628', color: '#fff', marginTop: 10, padding: '4px 14px', fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer' }}>Criar primeira oportunidade</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {lista.map(op => {
            const etapa = etapaInfo(op.etapa);
            const etapaIdx = ETAPAS.findIndex(e => e.key === op.etapa);
            const anterior = etapaIdx > 0 ? ETAPAS[etapaIdx - 1] : null;
            const proximo = etapaIdx < ETAPAS.length - 1 ? ETAPAS[etapaIdx + 1] : null;
            const expandido = expandidas[op._id];
            return (
              <div key={op._id} style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: '8px 12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <div style={{ background: etapa.cor, color: '#fff', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {etapa.label}
                  </div>
                  <div style={{ flex: 1, minWidth: 160 }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#0a1628' }}>{op.nome_cliente}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 1, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
                      {op.telefone && (
                        <>
                          <span>{op.telefone}</span>
                          <button
                            onClick={() => window.open(`https://web.whatsapp.com/send?phone=${(op.whatsapp_tel || op.telefone).replace(/\D/g, '')}`, '_blank')}
                            title="Abrir WhatsApp"
                            style={{ background: '#25d366', color: '#fff', border: 'none', borderRadius: 4, padding: '1px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer', lineHeight: 1.6 }}>
                            💬 WA
                          </button>
                          <button
                            onClick={() => {
                              const num = op.telefone.replace(/\D/g, '');
                              if (navigator.clipboard) {
                                navigator.clipboard.writeText(num).catch(() => { const el = document.createElement('textarea'); el.value = num; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); });
                              } else { const el = document.createElement('textarea'); el.value = num; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); }
                            }}
                            title="Copiar número"
                            style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '1px 8px', fontSize: 11, cursor: 'pointer', lineHeight: 1.6 }}>
                            📋
                          </button>
                        </>
                      )}
                      {op.sdr && <span>SDR: {op.sdr}</span>}
                      {op.closer && <span>Closer: {op.closer}</span>}
                    </div>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 2, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 11, color: '#9ca3af' }}>{formatarData(op.criado_em)}</span>
                      {op.ultima_mensagem_em && (() => {
                        const diff = (Date.now() - new Date(op.ultima_mensagem_em).getTime()) / 1000 / 60;
                        const cor = diff < 180 ? '#16a34a' : diff < 1440 ? '#d97706' : '#dc2626';
                        const bg  = diff < 180 ? '#f0fdf4' : diff < 1440 ? '#fffbeb' : '#fef2f2';
                        const txt = diff < 60 ? `${Math.round(diff)}min` : diff < 1440 ? `${Math.round(diff/60)}h` : `${Math.round(diff/1440)}d`;
                        return <span title={`Última mensagem: ${new Date(op.ultima_mensagem_em).toLocaleString('pt-BR')}`} style={{ fontSize: 11, background: bg, color: cor, padding: '1px 6px', borderRadius: 10, fontWeight: 700, border: `1px solid ${cor}33` }}>msg: {txt}</span>;
                      })()}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                    {anterior && (
                      <button onClick={() => moverEtapa(op, anterior.key)} title={`Mover para ${anterior.label}`}
                        style={{ background: '#f3f4f6', color: '#374151', padding: '2px 8px', fontSize: 12, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>◀</button>
                    )}
                    {proximo && (
                      <button onClick={() => moverEtapa(op, proximo.key)} title={`Mover para ${proximo.label}`}
                        style={{ background: etapa.cor, color: '#fff', padding: '2px 8px', fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer' }}>▶</button>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => toggleExpandir(op._id)}
                      style={{ background: expandido ? '#0a1628' : '#f0f4ff', color: expandido ? '#fff' : '#0a1628', fontSize: 12, padding: '2px 10px', borderRadius: 4, border: '1px solid #0a162844', cursor: 'pointer', fontWeight: 600 }}>
                      Tarefas
                    </button>
                    <button onClick={() => abrirEditar(op)} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', padding: '2px 10px', fontSize: 12, borderRadius: 4, cursor: 'pointer' }}>Editar</button>
                    <button onClick={() => setConfirmacao(op)} style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', padding: '2px 10px', fontSize: 12, borderRadius: 4, cursor: 'pointer' }}>Excluir</button>
                  </div>
                </div>
                {expandido && <TarefasOportunidade op={op} />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
